import { render, staticRenderFns } from "./NbDropdown.vue?vue&type=template&id=7ca0a04a"
import script from "./NbDropdown.vue?vue&type=script&lang=js"
export * from "./NbDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports